document.addEventListener("DOMContentLoaded", () => {
  const searchParams = localStorage.getItem("searchParams");

  if (searchParams) {
    const links = document.querySelectorAll('a[href$="collections/all"]');

    links.forEach((link) => {
      if (link.classList.contains("active-facets__button-remove--remove-all")) {
        return;
      }
      const url = new URL(link.href);
      url.search = searchParams;
      link.href = url.toString();
    });
  }
});

const handleSuiteFilter = () => {
  throw new Error("Stao sam ovde");
};

class WarrantyOptionInclude extends HTMLElement {
  constructor() {
    super();
    this.warrantiesBtnsLogic();

    this.addEventListener("warranty::change", () => {
      const selected = this.querySelector(".warranty-btn.selected");
      this.querySelector(".selected-option")?.classList.add("option-selected");

      let aditionalQty = 1;
      if (this.querySelector(".selected-option")) {
        this.querySelector(".selected-option").innerHTML =
          selected.querySelector(".warranty-badge")
            ? `<span class="selected-option--badge">${
                selected.querySelector(".warranty-badge").textContent
              }</span> ${
                selected.dataset.variantPrice
                  ? "+$" +
                    `<span class='addons-price' data-base-price="${(
                      parseFloat(selected.dataset.variantPrice).toFixed(2) *
                      aditionalQty
                    ).toFixed(2)}">` +
                    (
                      parseFloat(selected.dataset.variantPrice).toFixed(2) *
                      aditionalQty
                    ).toFixed(2) +
                    "</span>"
                  : "Basic"
              }`
            : `${
                selected.dataset.variantPrice
                  ? "+$" +
                    `<span class='addons-price' data-base-price="${(
                      parseFloat(selected.dataset.variantPrice).toFixed(2) *
                      aditionalQty
                    ).toFixed(2)}">` +
                    (
                      parseFloat(selected.dataset.variantPrice).toFixed(2) *
                      aditionalQty
                    ).toFixed(2) +
                    "</span>"
                  : "Basic"
              }`;
      }
    });
  }

  warrantiesBtnsLogic() {
    const warranties = this.querySelectorAll("ul li");
    document.addEventListener("DOMContentLoaded", () => {
      warranties[0].querySelector(".warranty-btn").click();
    });

    //to make it work with the other parts of code adding one event listener
    warranties.forEach((warranty, index) => {
      if (index == 0) return;
      const warrantyBtn = warranty.querySelector(".warranty-btn");
      warrantyBtn.addEventListener("click", () => {
        this.dataset.added = this.dataset.added == "true";
        // this.handleAddRemoveText();
      });
    });

    if (window.location.href.includes("product_addons=")) {
      const urlParams = new URLSearchParams(window.location.search);
      const addons = urlParams.get("product_addons");

      warranties.forEach((warranty, index) => {
        if (index == 0) return;
        const warrantyBtn = warranty.querySelector(".warranty-btn");
        if (!addons.includes(warrantyBtn.dataset.variantId)) {
          return;
        }
        this.dataset.added = this.dataset.added = "true";
        // this.handleAddRemoveText();
      });
    }
  }
}

customElements.define("warranty-option-include", WarrantyOptionInclude);

class ServiceOption extends HTMLElement {
  constructor() {
    super();

    this.servicesBtnsLogic();

    this.addEventListener("service::change", () => {
      const selected = this.querySelector("input:checked");
      this.querySelector(".selected-option")?.classList.add("option-selected");
      let aditionalQty = 1;
    });
  }

  servicesBtnsLogic() {
    const serviceOptions = this.querySelectorAll(".js-option");
    document.addEventListener("DOMContentLoaded", () => {
      serviceOptions[0].click();
    });

    //to make it work with the other parts of code adding one event listener
    serviceOptions.forEach((warranty, index) => {
      if (index == 0) return;
      const warrantyBtn = warranty.querySelector("input");
      warrantyBtn.addEventListener("click", () => {
        this.dataset.added = this.dataset.added == "true";
        // this.handleAddRemoveText();
      });
    });

    if (window.location.href.includes("product_addons=")) {
      const urlParams = new URLSearchParams(window.location.search);
      const addons = urlParams.get("product_addons");

      serviceOptions.forEach((warranty, index) => {
        if (index == 0) return;
        const warrantyBtn = warranty.querySelector("input");
        if (!addons.includes(warrantyBtn.dataset.variantId)) {
          return;
        }
        this.dataset.added = this.dataset.added = "true";
        // this.handleAddRemoveText();
      });
    }
  }

  handleAddRemoveText() {
    this.addRemoveWarranty.textContent =
      this.dataset.added == "true" ? "Remove" : "+ Add";
  }
}
customElements.define("service-option", ServiceOption);

class WholesaleForm extends HTMLElement {
  constructor() {
    super();
    this.closest("div")
      .querySelector(".wholesale-form-opener")
      .addEventListener("click", (e) => {
        e.preventDefault();
        this.classList.add("show");
      });
    this.querySelectorAll(".wf__continue-btn, .form-overlay").forEach((el) => {
      el.addEventListener("click", () => {
        this.classList.remove("show");
      });
    });

    this.querySelector("form").addEventListener("submit", function (event) {
      event.preventDefault();

      const form = event.target;

      const formData = {
        type: "wholesale",
        date: form.querySelector("#date").value,
        name: form.querySelector("#name").value,
        email: form.querySelector("#email").value,
        phone: form.querySelector("#phone").value,
        message: form.querySelector("#message").value,
      };

      const formActionUrl = form.action;

      fetch(formActionUrl, {
        body: JSON.stringify(formData),
        redirect: "follow",
        method: "POST",
        headers: {
          "Content-Type": "text/plain;charset=utf-8",
        },
      })
        .then((response) => response.text())
        .then((data) => {
          form.closest("wholesale-form").classList.add("success");
        })
        .catch((error) => {
          console.error("Error:", error);
          form.closest("wholesale-form").classList.add("success");
        });
    });
  }
}
customElements.define("wholesale-form", WholesaleForm);

class CustomSliderButtons extends HTMLElement {
  constructor() {
    super();

    this.nextButton = this.querySelector(".csb--next");
    this.prevButton = this.querySelector(".csb--prev");

    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));

    this.elements = Array.from(
      this.closest("media-gallery").querySelectorAll(`li.thumbnail-list__item`),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    this.triggerSlide(event.currentTarget.name);
  }

  triggerSlide(name) {
    // We need to get the order from the thumbnails, but find the active one in the main viewer
    const mediaGallery = this.closest("media-gallery");
    this.elements = Array.from(
      mediaGallery.querySelectorAll(`li.thumbnail-list__item`),
    );
    const mainViewerSlides = Array.from(
      mediaGallery.querySelectorAll(".product__media-item.slider__slide"),
    );

    const currentSlide = this.closest("media-gallery")
      .querySelector(`button.thumbnail[aria-current="true"]`)
      .closest("li");
    const currentIndex = this.elements.indexOf(currentSlide);

    let element =
      name === "next"
        ? this.elements
            .slice(currentIndex)
            .find(
              (el) =>
                !el.querySelector(`button.thumbnail[aria-current="true"]`) &&
                !el.classList.contains("hide-image") &&
                !el.classList.contains("custom-hidden"),
            )
        : this.elements
            .slice(0, currentIndex)
            .reverse()
            .find(
              (el) =>
                !el.querySelector(`button.thumbnail[aria-current="true"]`) &&
                !el.classList.contains("hide-image") &&
                !el.classList.contains("custom-hidden"),
            );
    const isBundle = this.closest(".product-is-bundle");
    if (isBundle) {
      element =
        name === "next"
          ? this.elements
              .slice(currentIndex)
              .find(
                (el) =>
                  !el.querySelector(`button.thumbnail[aria-current="true"]`),
              )
          : this.elements
              .slice(0, currentIndex)
              .reverse()
              .find(
                (el) =>
                  !el.querySelector(`button.thumbnail[aria-current="true"]`),
              );
    }
    element
      ? element.querySelector("button").click()
      : console.error("SOmething went wrong");
    // if (name === "next" && !element) {
    //   this.elements[0].querySelector("button").click();
    // }

    if (name === "prev" && !element && currentIndex == 1) {
      this.closest("media-gallery")
        .querySelector(`li.thumbnail-list__item`)
        .querySelector("button")
        .click();
    }
  }
}

customElements.define("custom-slider-buttons", CustomSliderButtons);

class ClearCartBtn extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector("button");
    this.btn.addEventListener("click", this.clearCart.bind(this));
  }
  clearCart() {
    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        window.location.reload();
      })
      .catch((error) => console.error("Error clearing cart:", error));
  }
}
customElements.define("clear-cart-btn", ClearCartBtn);
// window.addEventListener("DOMContentLoaded", () => {
//   const button = document.createElement("button");
//   button.style.zIndex = "9999";
//   button.style.position = "fixed";
//   button.style.left = "10px";
//   button.style.top = "10px";
//   button.textContent = "CLEAR CART";
//   button.addEventListener("click", () => {
//     fetch("/cart/clear.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//       .then((response) => {
//         if (response.ok) {
//           console.log("Cart cleared successfully");
//           return response.json();
//         } else {
//           throw new Error("Failed to clear cart");
//         }
//       })
//       .then((data) => {
//         console.log(data);
//         window.location.reload();
//       })
//       .catch((error) => console.error("Error clearing cart:", error));
//   });
//   document.body.appendChild(button);
// });

window.addEventListener("filter::changed", (event) => {
  let filterSelected = event.detail;

  let thumbGallery = document.querySelector(
    ".thumbnail-slider.slider-mobile-gutter.quick-add-hidden",
  );

  let sliderBtns = document.querySelector("custom-slider-buttons");
  if (window.innerWidth < 769) {
    thumbGallery = document.querySelector(
      "product-info  .thumbnail-slider.slider-mobile-gutter.quick-add-hidden",
    );
    sliderBtns = document.querySelector("product-info  custom-slider-buttons");
  }
  const firstSlide = thumbGallery.querySelector(
    ".thumbnail-list__item.slider__slide",
  );
});

class CartAddonSelector extends HTMLElement {
  static observedAttributes = ["selected-option"];
  cartContent = null;
  cartItemsParent = null;
  cartItem = null;
  constructor() {
    super();
    this.key = this.getAttribute("key");
    this.cartItemsParent = this.closest("cart-items");
    this.cartItem = this.closest(".cart-item");
    this.animateInput = null;
    this.querySelectorAll("input").forEach((input) => {
      input.addEventListener("change", this.handleInputChange.bind(this));
    });
  }
  handleInputChange(e) {
    this.animateInput = e.target;
    this.setAttribute("selected-option", e.target.value);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "selected-option":
        this.handleOptionChange(oldValue, newValue);
        break;
    }
  }
  async fetchCartData() {
    await fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        this.cartContent = cart;
      })
      .catch((error) => {
        throw new Error("ERROR! fetching data from the cart!!!");
      });
  }
  getCartItemByKey() {
    const result = this.cartContent.items.find(
      (cartItem) => cartItem.key === this.key,
    );
    if (result === null) {
      throw new Error("ERROR! there is no item with key: " + key);
    }
    return result;
  }
  async removeCartItem(value) {
    const itemToRemove = this.cartContent.items.find(
      (cartItem) =>
        cartItem.id === Number(value) &&
        cartItem.properties._for_product ===
          this.getCartItemByKey().id.toString(),
    );
    if (!itemToRemove) {
      throw new Error(
        "ERROR! there is no item to remove with mathing conditions " + value,
      );
    }
    const data = {
      id: itemToRemove.key,
      quantity: 0,
    };
    await this.cartAction(data, "cart/change.js");
  }
  async cartAction(formData, action) {
    await fetch(window.Shopify.routes.root + action, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: typeof formData !== "string" ? JSON.stringify(formData) : formData,
    })
      .then((response) => response.json())
      .catch((error) => {
        console.error("error: ", error);
        throw new Error(error);
      });
  }
  async handleOptionChange(oldValue, newValue) {
    if (oldValue === newValue || oldValue === null || oldValue === "null") {
      return;
    }
    this.cartItemsParent.enableLoading(
      this.cartItem.getAttribute("id").replace("CartItem-", ""),
    );

    const label = this.animateInput?.closest(".addon-selector");
    if (label) {
      label.querySelector(".price")?.classList.add("hidden");
      label
        .querySelector(".flowbite-loading-spinner")
        ?.classList.remove("hidden");
    }

    try {
      await this.fetchCartData();
      const item = this.getCartItemByKey();
      const formData = {
        items: [],
      };

      if (newValue !== "") {
        formData.items.push({
          id: parseInt(newValue),
          quantity: item.quantity,
          properties: {
            type: "addon",
            _product_type: item.properties._product_type,
            _for_product: item.id.toString(),
            __covered_barcode:
              this.querySelector("input:checked")?.dataset.barcode,
          },
        });
      }

      if (oldValue !== "") {
        this.removeCartItem(oldValue);
        await sleep(1050);
      }
      if (formData.items.length === 0) {
        return;
      }
      await this.cartAction(formData, "cart/add.js");
    } catch (e) {
      throw new Error(e);
    } finally {
      await sleep(300);
      const input = this.closest("tr").querySelector("input.quantity__input");
      const tableRow = this.closest("tr");
      const parent = tableRow.parentNode;
      const children = Array.from(parent.children);
      const index = children.indexOf(tableRow);
      this.cartItemsParent.updateQuantity(
        index,
        input.value,
        input.getAttribute("name"),
        input.dataset.quantityVariantId,
      );
    }
  }
}
customElements.define("cart-addon-selector", CartAddonSelector);
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

class CustomerToggle extends HTMLElement {
  constructor() {
    super();
    this.customerToggleApiUrl =
      "https://secondshop-apps-be57801288424ab9b804.o2.myshopify.dev/toggle-customer-tag";
    this.typeOptions = [];
    this.activeOption = undefined;
  }

  connectedCallback() {
    this.initOptions();
  }

  initOptions() {
    this.typeOptions = this.querySelectorAll(".customer-type-toggle__option");
    this.typeOptions.forEach((option) => {
      option.addEventListener("click", () => {
        this.toggleActiveTypeOption(option);
        this.toggleCustomerType(option);
      });
    });

    this.activeOption = this.querySelector(
      ".customer-type-toggle__option.active",
    );
  }

  toggleActiveTypeOption(option) {
    if (this.activeOption) this.activeOption.classList.remove("active");
    option.classList.add("active");
    this.activeOption = option;
  }

  toggleCustomerType(option) {
    const customerId = window.meta.page.customerId;
    if (!customerId) return;

    let formData = new FormData();
    formData.append("customerId", customerId);

    option.classList.add("loading");
    option.querySelector(".loading__spinner").classList.remove("hidden");
    fetch(this.customerToggleApiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        clearCart();
        option.classList.remove("loading");
        option.querySelector(".loading__spinner").classList.add("hidden");
      })
      .catch((error) => {
        window.location.reload(); // if there was an error, reload page to fetch new type of customer
        console.error("Error:", error);
      });
  }
}

customElements.define("customer-toggle", CustomerToggle);

function clearCart() {
  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      window.location.reload();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

//New code top selling
class FeaturedProducts extends HTMLElement {
  constructor() {
    super();

    this.initLogic();
  }
  initLogic() {
    if (this.dataset.isSlider === "false") {
      this.initCustomSlider();
      return;
    }
    this.swiper = null;
    this.randomNum = Math.round(Math.random() * 10000);
    this.swiperEl = this.querySelector(".further-reduced-swiper");
    this.initSwiper = this.initSwiper.bind(this);
    this.sectionrenderLogic();
    this.isCollection = this.dataset.isCollection == "true" ? true : false;
  }
  initCustomSlider() {
    // Only initialize custom slider above 992px
    if (window.innerWidth < 992) {
      return;
    }

    const grid = this.querySelector(".featured-products__grid");
    const leftArrow = this.querySelector(
      ".custom-slider-navigation .chevron-left",
    );
    const rightArrow = this.querySelector(
      ".custom-slider-navigation .chevron-right",
    );

    if (!grid || !leftArrow || !rightArrow) return;

    // Add custom slider class
    grid.classList.add("custom-slider");

    // Calculate scroll amount based on container width dynamically
    const getScrollAmount = () => {
      const containerWidth = grid.clientWidth;
      const itemMinWidth = 280;
      const gap = 24;

      // Calculate how many items can fit
      const itemsVisible = Math.floor(
        (containerWidth + gap) / (itemMinWidth + gap),
      );
      const actualItemWidth =
        (containerWidth - gap * (itemsVisible - 1)) / itemsVisible;

      return actualItemWidth + gap;
    };

    // Left arrow click handler
    leftArrow.addEventListener("click", () => {
      const scrollAmount = getScrollAmount();
      grid.scrollBy({
        left: -scrollAmount,
        behavior: "smooth",
      });
    });

    // Right arrow click handler
    rightArrow.addEventListener("click", () => {
      const scrollAmount = getScrollAmount();
      grid.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    });

    // Update arrow visibility based on scroll position
    const updateArrowVisibility = () => {
      const isAtStart = grid.scrollLeft <= 0;
      const isAtEnd =
        grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 1;

      leftArrow.style.opacity = isAtStart ? "0.5" : "1";
      leftArrow.style.pointerEvents = isAtStart ? "none" : "auto";
      rightArrow.style.opacity = isAtEnd ? "0.5" : "1";
      rightArrow.style.pointerEvents = isAtEnd ? "none" : "auto";
    };

    grid.addEventListener("scroll", updateArrowVisibility);
    updateArrowVisibility(); // Initial check

    // Re-initialize on window resize if still above 992px
    const handleResize = () => {
      if (window.innerWidth < 992) {
        grid.classList.remove("custom-slider");
        leftArrow.removeEventListener("click", this.handleLeftClick);
        rightArrow.removeEventListener("click", this.handleRightClick);
        grid.removeEventListener("scroll", updateArrowVisibility);
      } else {
        updateArrowVisibility();
      }
    };

    window.addEventListener("resize", handleResize);
  }
  sectionrenderLogic() {
    if (!this.swiperEl) return;

    const initSwiper = () => {
      const isAboveFold = this.getBoundingClientRect().top < window.innerHeight;

      if (isAboveFold) {
        window.swiperLoader.initImmediately(this.initSwiper);
      } else {
        const viewportHeight = window.innerHeight;
        window.swiperLoader.initWhenVisible(this, this.initSwiper, {
          rootMargin: `${viewportHeight}px`,
          threshold: 0.1,
        });
      }
    };

    if (window.swiperLoader) {
      initSwiper();
    } else {
      window.addEventListener("swiperloader:ready", initSwiper, { once: true });
    }

    window.addEventListener("resize", () => {
      if (this.swiper && window.Swiper) {
        this.initSwiper(window.Swiper);
      }
    });
  }
  hideSection() {
    this.ariaHidden = "true";
  }
  showSection() {
    this.ariaHidden = "false";
  }
  initSwiper(Swiper) {
    if (!Swiper) return;

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    const swiperId = "featured-product-swiper-" + this.randomNum;
    const arrowLeft = this.querySelector(".chevron-left");
    const arrowRight = this.querySelector(".chevron-right");
    arrowLeft.classList.add(`${swiperId}-arrow-left`);
    arrowRight.classList.add(`${swiperId}-arrow-right`);
    this.swiperEl.classList.add(swiperId);
    const config = {
      initialSlide: Number(this.dataset.initialSlide),
      slidesPerView: "auto",
      centeredSlides: Number(this.dataset.initialSlide) > 0,
      loop: false,
      spaceBetween: 16,
      navigation: {
        prevEl: `.${swiperId}-arrow-left`,
        nextEl: `.${swiperId}-arrow-right`,
      },
      breakpoints: {
        768: {
          slidesPerView: this.isCollection ? 1 : 2,
          loop: false,
          centeredSlides: false,
          initialSlide: this.isCollection ? 1 : 0,
        },
        950: {
          initialSlide: 0,
          slidesPerView: 2,
          loop: false,
          centeredSlides: false,
        },
        1200: {
          initialSlide: 0,
          slidesPerView: 3,
          loop: false,
          centeredSlides: false,
        },
        1250: {
          initialSlide: 0,
          spaceBetween: 32,
          slidesPerView: this.dataset.desktopSlides
            ? this.dataset.desktopSlides == "auto"
              ? "auto"
              : Number(this.dataset.desktopSlides)
            : 4,
          loop: false,
          centeredSlides: false,
        },
      },
    };
    if (this.closest("shop-page-content")) {
      config.breakpoints["768"].slidesPerView = 2;
    }
    this.swiper = new Swiper(`.${swiperId}`, config);

    let minHeight = 0;
    let minImgHeight = 0;
    const slides = this.swiperEl.querySelectorAll(".swiper-slide");
    slides.forEach((slide) => {
      const computedStyle = window.getComputedStyle(slide);
      const heightWithoutPadding =
        slide.clientHeight -
        parseFloat(computedStyle.paddingTop) -
        parseFloat(computedStyle.paddingBottom);
      if (heightWithoutPadding > minHeight) minHeight = heightWithoutPadding;
      const imgHeight = slide.querySelector("img")?.offsetHeight || 0;
      if (imgHeight > minImgHeight) minImgHeight = imgHeight;
    });
    slides.forEach((slide) => {
      const img = slide.querySelector("img");
      slide.style.minHeight =
        minHeight + Math.max(minImgHeight - img?.offsetHeight || 0, 0) + "px";
      // if (img) {
      //   img.style.height = minImgHeight + "px";
      // }
    });
    this.showSection();
  }
}
customElements.define("featured-products", FeaturedProducts);
//end of top selling

// Furhter reduced
class FurtherReduced extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.randomNum = Math.round(Math.random() * 10000);
    this.swiperEl = this.querySelector(".further-reduced-swiper");
    this.initSwiper = this.initSwiper.bind(this);
    this.sectionrenderLogic();
    this.isCollection = this.dataset.isCollection == "true" ? true : false;
  }
  sectionrenderLogic() {
    if (!this.swiperEl) return;

    const initSwiper = () => {
      const isAboveFold = this.getBoundingClientRect().top < window.innerHeight;

      if (isAboveFold) {
        window.swiperLoader.initImmediately(this.initSwiper);
      } else {
        const viewportHeight = window.innerHeight;
        window.swiperLoader.initWhenVisible(this, this.initSwiper, {
          rootMargin: `${viewportHeight}px`,
          threshold: 0.1,
        });
      }
    };

    if (window.swiperLoader) {
      initSwiper();
    } else {
      window.addEventListener("swiperloader:ready", initSwiper, { once: true });
    }

    window.addEventListener("resize", () => {
      if (this.swiper && window.Swiper) {
        this.initSwiper(window.Swiper);
      }
    });
  }
  hideSection() {
    this.ariaHidden = "true";
  }
  showSection() {
    this.ariaHidden = "false";
  }
  initSwiper(Swiper) {
    if (!Swiper) return;

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    const swiperId = "featured-product-swiper-" + this.randomNum;
    const mainParent = this.closest(".further-reduced-section-class");
    const arrowLeft = mainParent?.querySelector(".chevron-left");
    const arrowRight = mainParent?.querySelector(".chevron-right");
    if (!arrowLeft || !arrowRight) return;
    arrowLeft.classList.add(`${swiperId}-arrow-left`);
    arrowRight.classList.add(`${swiperId}-arrow-right`);
    this.swiperEl.classList.add(swiperId);
    this.swiper = new Swiper(`.${swiperId}`, {
      slidesPerView: "auto",
      centeredSlides: true,
      loop: false,
      initialSlide: 1,
      spaceBetween: 16,
      navigation: {
        prevEl: `.${swiperId}-arrow-left`,
        nextEl: `.${swiperId}-arrow-right`,
      },
      breakpoints: {
        768: {
          slidesPerView: this.isCollection ? 1 : 2,
          loop: false,
          centeredSlides: false,
          initialSlide: this.isCollection ? 1 : 0,
        },
        950: {
          initialSlide: 0,
          slidesPerView: 2,
          loop: false,
          centeredSlides: false,
        },
        1250: {
          initialSlide: 0,
          slidesPerView: this.dataset.desktopSlides
            ? Number(this.dataset.desktopSlides)
            : 4,
          loop: false,
          centeredSlides: false,
        },
      },
    });

    let minHeight = 0;
    let minImgHeight = 0;
    const slides = this.swiperEl.querySelectorAll(".swiper-slide");
    slides.forEach((slide) => {
      const computedStyle = window.getComputedStyle(slide);
      const heightWithoutPadding =
        slide.clientHeight -
        parseFloat(computedStyle.paddingTop) -
        parseFloat(computedStyle.paddingBottom);
      if (heightWithoutPadding > minHeight) minHeight = heightWithoutPadding;
      const imgHeight = slide.querySelector("img")?.offsetHeight || 0;
      if (imgHeight > minImgHeight) minImgHeight = imgHeight;
    });
    slides.forEach((slide) => {
      slide.style.minHeight = minHeight + "px";
      const img = slide.querySelector("img");
      if (img) {
        img.style.minHeight = minImgHeight + "px";
      }
    });
    this.showSection();
  }
}
customElements.define("further-reduced", FurtherReduced);

class SliderContainer extends HTMLElement {
  #filled = true;
  constructor() {
    super();

    this.content = this.querySelector(".sc__content");

    this.querySelectorAll(".close-btn, .overlay").forEach((closeBtn) => {
      closeBtn.addEventListener("click", () => {
        this.close();
      });
    });
  }

  fillContent(HTMLString) {
    try {
      this.content.innerHTML = HTMLString;
      this.#filled = true;
    } catch (error) {
      this.#filled = false;
      throw new Error(error);
    }
  }

  open() {
    if (this.#filled === false) {
      console.error("ERROR! When filling can't open the slider");
      return;
    }
    this.classList.add("opening");
    setTimeout(() => {
      this.classList.add("open");
      this.classList.remove("opening");
    }, 100);
  }

  close() {
    this.classList.add("closing");
    setTimeout(() => {
      this.classList.remove("open");
      this.classList.remove("closing");
    }, 700);
  }
}

customElements.define("slider-container", SliderContainer);

class ReferPopup extends HTMLElement {
  constructor() {
    super();
    this._initEvents();
  }

  _initEvents() {
    this._initClosing();
    this._openingLogic();
    this._referLogic();
  }

  _openingLogic() {
    // Check if the popup was closed today
    const closedDate = localStorage.getItem("popupClosedDate");
    const today = new Date().toDateString();

    // If the popup was closed today, don't show it again
    if (closedDate === today) {
      return;
    }

    const onScroll = () => {
      if (window.scrollY > 100) {
        this.open();
        window.removeEventListener("scroll", onScroll);
      }
    };
    window.addEventListener("scroll", onScroll);
  }

  _initClosing() {
    this.querySelectorAll(".js-rp__close-btn, .overlay").forEach((el) => {
      el.addEventListener("click", () => {
        this.close();
      });
    });
  }

  _checkIfReferalPage() {
    if (
      window.location.href.includes("/pages/referral") ||
      localStorage.getItem("customer-page-refered") == "true"
    ) {
      return true;
    }
    return false;
  }

  _referLogic() {
    // Add any referral-related logic here if needed
  }

  open() {
    if (this._checkIfReferalPage()) {
      return;
    }
    this.classList.add("opening");
    setTimeout(() => {
      this.classList.add("open");
      this.classList.remove("opening");
    }, 600);
  }

  close() {
    this.classList.add("closing");
    setTimeout(() => {
      this.classList.remove("closing");
      this.classList.remove("open");
      // Uncomment if you want to prevent reopening until tomorrow:
      // const today = new Date().toDateString();
      // localStorage.setItem("popupClosedDate", today);
    }, 600);
  }
}

customElements.define("refer-popup", ReferPopup);

class FinacingInfoPopup extends HTMLElement {
  constructor() {
    super();
    this.variantPrice = Number(this.dataset.price);

    this.querySelectorAll(".fip__btn, .overlay").forEach((closeEl) => {
      closeEl.addEventListener("click", () => {
        this.close();
      });
    });

    this.getTriggerBtns();

    window.addEventListener("pm-price-update", (e) => {
      const newPrice = Number(e?.detail?.data?.salePriceCents?.number);
      if (isNaN(newPrice)) return;
      if (this.variantPrice <= newPrice) {
        return;
      }
      if (window.location.pathname == "/cart") {
        return;
      }
      const discountPercentage = 5;
      const discountAmount = (newPrice * discountPercentage) / 100;
      const discountedPrice = newPrice + discountAmount;
      this.querySelectorAll(".fip__price-per-month, .fip__sub-price").forEach(
        (el) => {
          el.innerHTML = `$${Number(
            (discountedPrice / 12 / 100).toFixed(2),
          ).toLocaleString()}/mo*`;
        },
      );

      this.querySelectorAll(".fip__variant-price").forEach((price) => {
        price.innerHTML = `$${(newPrice / 100).toLocaleString()}`;
      });
    });
  }

  close() {
    this.classList.add("closing");
    setTimeout(() => {
      this.classList.remove("show");
      this.classList.remove("closing");
    }, 500);
  }

  open() {
    this.classList.add("show");
  }

  getTriggerBtns() {
    document.querySelectorAll(".finance-box__open-popup-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        this.open();
      });
    });
  }
}

customElements.define("finacing-info-popup", FinacingInfoPopup);

class ConditionsPopup extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll(".cp__btn, .overlay").forEach((closeEl) => {
      closeEl.addEventListener("click", () => {
        this.close();
      });
    });

    this.getTriggerBtns();
  }

  close() {
    this.classList.add("closing");
    setTimeout(() => {
      this.classList.remove("show");
      this.classList.remove("closing");
    }, 500);
  }

  open() {
    this.classList.add("show");
  }

  setCondition(condition) {
    this.dataset.condition = condition;
  }

  _openConditionPopup(condition) {
    const conditionPopup = document.querySelector("conditions-popup");
    conditionPopup.setCondition(condition);
    conditionPopup.open();
  }

  getTriggerBtns() {
    const statuses = document.querySelectorAll(".cb-filters__condition-status");
    statuses.forEach((status) => {
      status.addEventListener("click", () => {
        if (!status.classList.contains("selected-status")) {
          return;
        }
        const condition = status.closest(".ppf-checked").dataset.value;
        this._openConditionPopup(condition);
      });
    });
  }
}

customElements.define("conditions-popup", ConditionsPopup);

class HeroBanner extends HTMLElement {
  constructor() {
    super();
    // this._initHeight();

    // document.addEventListener("DOMContentLoaded", () => {
    //   this._initHeight();
    // });
    // window.addEventListener("resize", () => {
    //   this._initHeight();
    // });

    this.randomNum = Math.round(Math.random() * 10000);

    this.swiperEl = this.querySelector(".hero-banner-swiper");
    this._initSwiper = this._initSwiper.bind(this);
    this._sectionrenderLogic();

    this.querySelectorAll(".swiper-button-prev-trigger").forEach((el) => {
      el.addEventListener("click", () => {
        this.querySelector(".swiper-button-prev").click();
      });
    });
    this.querySelectorAll(".swiper-button-next-trigger").forEach((el) => {
      el.addEventListener("click", () => {
        this.querySelector(".swiper-button-next").click();
      });
    });
  }

  _sectionrenderLogic() {
    if (!this.swiperEl) return;

    const initSwiper = () => {
      const isAboveFold = this.getBoundingClientRect().top < window.innerHeight;

      if (isAboveFold) {
        window.swiperLoader.initImmediately(this._initSwiper);
      } else {
        const viewportHeight = window.innerHeight;
        window.swiperLoader.initWhenVisible(this, this._initSwiper, {
          rootMargin: `${viewportHeight}px`,
          threshold: 0.1,
        });
      }
    };

    if (window.swiperLoader) {
      initSwiper();
    } else {
      window.addEventListener("swiperloader:ready", initSwiper, { once: true });
    }

    window.addEventListener("resize", () => {
      this.style.removeProperty("--slides-height");
      setTimeout(() => {
        if (this.swiper && window.Swiper) {
          this._initSwiper(window.Swiper);
        }
      }, 80);
    });
  }

  _initSwiper(Swiper) {
    if (!Swiper) return;

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    const slides = this.querySelectorAll(".swiper-slide");
    let biggestHeight = Math.max(
      ...Array.from(slides).map((s) => s.offsetHeight),
    );

    //create a css variable for the height
    this.style.setProperty("--slides-height", `${biggestHeight}px`);

    const swiperId = "hero-banner-swiper-" + this.randomNum;
    const arrowLeft = this.querySelector(".swiper-button-prev");
    const arrowRight = this.querySelector(".swiper-button-next");
    if (arrowLeft && arrowRight) {
      arrowLeft.classList.add(`${swiperId}-arrow-left`);
      arrowRight.classList.add(`${swiperId}-arrow-right`);
    }
    this.swiperEl.classList.add(swiperId);
    const config = {
      slidesPerView: 1,
      centeredSlides: true,
      loop: false,
      // autoHeight: true,
      spaceBetween: 0,
      autoplay: {
        delay: 6000,
      },
      navigation: {
        prevEl: `.${swiperId}-arrow-left`,
        nextEl: `.${swiperId}-arrow-right`,
      },
    };

    this.swiper = new Swiper(`.${swiperId}`, config);

    //checking the height after init to be sure that the height is correct
    biggestHeight = Math.max(...Array.from(slides).map((s) => s.offsetHeight));

    //create a css variable for the height
    this.style.setProperty("--slides-height", `${biggestHeight}px`);
  }

  _initHeight() {
    if (window.screen.availWidth < 1092 || window.screen.availHeight < 1000) {
      this.style.height = "auto";
      this.classList.remove("dynamic-height--banner");
      return;
    }
    const itemsToSubstract = [
      "sticky-header",
      ".announcement-bar-section",
      ".as-seen-in-main-section",
      // ".guarantees-main-section-container",
    ];

    let heightSum = 0;
    itemsToSubstract.forEach((item) => {
      const itemEl = document.querySelector(item);
      if (!itemEl) {
        return;
      }
      heightSum += itemEl.offsetHeight;
    });

    this.style.height = `calc(100vh - ${heightSum}px)`;
    this.classList.add("dynamic-height--banner");
  }
}

customElements.define("hero-banner", HeroBanner);

class MarqueeItem extends HTMLElement {
  constructor() {
    super();
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    // Only adjust if the marquee is rotated
    if (
      this.classList.contains("marque-angle-direction-to-top") ||
      this.classList.contains("marque-angle-direction-to-bottom")
    ) {
      this.adjustParentHeight();
      window.addEventListener("resize", this.handleResize);
    }
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    this.adjustParentHeight();
  }

  adjustParentHeight() {
    const parent = this.closest(".angle-marquee-block");
    if (!parent) return;

    let minChildTop = Infinity;
    let maxChildBottom = -Infinity;

    const rotatedItems = parent.querySelectorAll(
      "marquee-item.marque-angle-direction-to-top, marquee-item.marque-angle-direction-to-bottom",
    );

    rotatedItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      minChildTop = Math.min(minChildTop, rect.top);
      maxChildBottom = Math.max(maxChildBottom, rect.bottom);
    });

    const parentRect = parent.getBoundingClientRect();
    const newHeight = maxChildBottom - Math.min(parentRect.top, minChildTop);
    parent.style.height = `${newHeight}px`;
  }
}

customElements.define("marquee-item", MarqueeItem);

class CustomRecommendations extends HTMLElement {
  constructor() {
    super();
    this.isAvailable = this.dataset.available === "true";
    this.url = this.dataset.url;
    this._innit();
  }

  _innit() {
    if (!this.isAvailable) {
      this._runOutOfStock();
      return;
    }
  }
  async getAlternativeCollection() {
    try {
      const response = await fetch(this.url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const htmlText = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, "text/html");

      const productGridCount = doc.querySelector("ul.product-grid");

      // get three first products
      const items = Array.from(productGridCount.querySelectorAll(".grid__item"))
        .filter((item) => item.children)
        .slice(0, 3);
      return items;
    } catch (error) {
      throw new Error("Error fetching or parsing HTML: " + error);
    }
  }
  async _runOutOfStock() {
    const items = await this.getAlternativeCollection();
    const container = this.querySelector(".product-grid");
    items.forEach((item) => {
      container.appendChild(item);
    });
  }
}

customElements.define("custom-recommendations", CustomRecommendations);

const refreshCartOnLogin = async () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has("just-logged-in")) {
    return;
  }
  try {
    const response = await fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    window.location.href = "/";
  } catch (error) {
    console.error("Error:", error);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  refreshCartOnLogin();
});

window.addEventListener("scroll", function () {
  const PDPPoup = this.document.querySelector(".react-responsive-modal-root");

  if (PDPPoup && !PDPPoup.classList.contains("show-popup")) {
    PDPPoup.classList.add("show-popup");
  }
});

class ProductManuals extends HTMLElement {
  constructor() {
    super();

    this.initElementsSize();
  }

  async getFileSize(url) {
    try {
      const response = await fetch(url, { method: "HEAD" });

      if (!response.ok) {
        throw new Error("Failed to fetch headers");
      }

      const size = response.headers.get("Content-Length");
      if (size !== null) {
        return Number(size);
      } else {
        console.error("Content-Length header not available");
        return null;
      }
    } catch (error) {
      console.error("Error getting file size:", error);
      return null;
    }
  }
  initElementsSize() {
    const linkEls = this.querySelectorAll(".product-manuals__link");
    linkEls.forEach(async (el) => {
      const sizeBlock = el.querySelector(".product-manuals__file-size");
      const size = await this.getFileSize(el.href);
      if (size) {
        sizeBlock.innerHTML = `${(Number(size) / (1024 * 1024)).toFixed(2)} MB`;
      }
    });
  }
}

customElements.define("product-manuals", ProductManuals);

class TruckloadSlider {
  constructor() {
    this.initAllSliders();
    window.addEventListener("resize", this.initAllSliders.bind(this));
  }

  initAllSliders() {
    document.querySelectorAll(".truckload-offer-box").forEach((box, idx) => {
      const swiperEl = box.querySelector(".truckload-swiper");
      if (!swiperEl || swiperEl.classList.contains("swiper-initialized"))
        return;
      const prevBtn = box.querySelector(".truckload-swiper-button-prev");
      const nextBtn = box.querySelector(".truckload-swiper-button-next");
      if (!window.Swiper) return;
      const swiper = new Swiper(swiperEl, {
        slidesPerView: "auto",
        spaceBetween: 12,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            spaceBetween: 8,
          },
          600: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
        },
        observer: true,
        observeParents: true,
      });
      swiperEl.classList.add("swiper-initialized");
    });
  }
}

function initTruckloadSlidersWhenReady() {
  window.swiperLoader.initImmediately((Swiper) => {
    new TruckloadSlider();
  });
}

document.addEventListener("DOMContentLoaded", initTruckloadSlidersWhenReady);
